import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Usuarios from '../views/Usuarios.vue'
import Aprovadores from '../views/Aprovadores.vue'
import Log from '../views/Log.vue'
// import Colaboracoes from '../views/Colaboracoes.vue'
import Moderacao from '../views/Moderacao.vue'
import Producoes from '../views/Producoes.vue'
import CallBack from '../views/CallBack.vue'
import TarjaView from '../views/TarjaView.vue'
import MosaicoView from '../views/MosaicoView.vue'
import store from "../store";
import ExibirNoticiasViewVue from '@/views/ExibirNoticiasView.vue'
import MosaicoPalavra from "@/components/Mosaico/MosaicoPalavra.vue";
import EnqueteView from '@/views/EnqueteView.vue'
import YoutubeCallBack from '@/views/YoutubeCallBack.vue'
import EnquetesCategorias from '@/views/EnquetesCategorias.vue'
import MosaicoCameras from '@/views/MosaicoCameras.vue'
import CamerasAdmin from '@/views/CamerasAdmin.vue'
import GloboGraphicsView from '@/views/GloboGraphicsView.vue'
import GloboGraphicsSettingsView from '@/views/GloboGraphicsSettingsView.vue'
import CenaView from '@/views/CenaView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: "/auth/callback",
    name: "callback",
    component: CallBack,
  },
  {
    path: '/',
    name: 'moderacao',
    component: Moderacao,
    meta: { login: true },
  },
  {
    path: '/usuarios',
    name: 'usuarios',
    component: Usuarios,
    meta: { login: true, isAdmin: true }
  },
  {
    path: '/aprovadores',
    name: 'aprovadores',
    component: Aprovadores,
    meta: { login: true, isAdmin: true }
  },
  {
    path: '/log',
    name: 'log',
    component: Log,
    meta: { login: true, isAdmin: true }
  },
  {
    path: '/producoes',
    name: 'producoes',
    component: Producoes,
    meta: { login: true, isAdmin: true }
  },
  {
    path: '/tarja',
    name: 'tarja',
    component: TarjaView,
    meta: { login: false, title: "Socialcam - TARJA"}
  },
  {
    path: '/mosaico',
    name: 'mosaico',
    component: MosaicoView,
    meta: { login: false, title: "Socialcam - MOSAICO"}
  },
  {
    path: '/mosaico-cameras',
    name: 'mosaico-cameras',
    component: MosaicoCameras,
    meta: { login: false, title: "Socialcam - MOSAICO CÂMERAS"}
  },
  {
    path: '/gnews',
    name: 'gnews',
    component: MosaicoPalavra,
    meta: { login: false, title: "Socialcam - GNEWS"}
  },
  {
    path: '/noticias',
    name: 'noticias',
    component: ExibirNoticiasViewVue,
    meta: { login: false, title: "Socialcam - Noticias"}
  },
  {
    path: '/enquete',
    name: 'enquete',
    component: EnqueteView,
    meta: { login: false, title: 'Socialcam - Enquete'}
  },
  {
    path: '/enquetes-categorias',
    name: 'enquetes-categorias',
    component: EnquetesCategorias,
    meta: { login: true, isAdmin: true }
  },
  {
    path: '/cameras',
    name: 'cameras',
    component: CamerasAdmin,
    meta: { login: true, isAdmin: true }
  },
  {
    path: '/youtube/callback',
    name: 'youtube',
    component: YoutubeCallBack,
    meta: { login: true}
  },
  {
    path: '/globographics',
    name: 'globographics',
    component: GloboGraphicsView,
    meta: { login: true, isAdmin: true }
  },
  {
    path: '/globographics/configuracoes',
    name: 'globographics-configuracoes',
    component: GloboGraphicsSettingsView,
    meta: { login: true, isAdmin: true }
  },
  {
    path: '/cena',
    name: 'cena',
    component: CenaView,
    meta: { login: false, title: 'Socialcam - Cena' }
  }
]

// No `base`: the SPA is served from the domain root. The `assetsDir: 'socialcam-frontend'`
// setting in vue.config.js only relocates the built asset files — it does not prefix routes,
// so giving the router that base would 404 every path.
const router = new VueRouter({
  mode: 'history',
  routes
})

// Proteção das rotas a partir do booleano "users/isAuthenticated",
// proveniente do modulo de usuário no Vuex Store.
router.beforeEach((to, from, next) => {
  if (to.matched.length < 1) {
    next("/");
  }

  // Caso o usuário esteja autenticado e for para página de login, é redirecionado para home.
  if (to.name === 'login') {
    if (store.getters["users/isAuthenticated"]) {

      next("/")
    }
  }

  if (to.matched.some(record => record.meta.login)) {
    if (store.getters["users/isAuthenticated"]) {

      if (to.matched.some(record => record.meta.isAdmin)) {
        if (store.getters["users/isAdm"]) {
          next();
        } else {
          next("/");
        }
      }

      next();
    } else {
      next("/login");
    }
  } else {
    next();
  }
});


export default router
